import { useCallback } from "react";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { useSettings } from "@components/settings/SettingsProvider";
import { WorkspaceSettingsPages } from "@components/settings/constants";

export const ReceiptPhoneNumberCommandIsland = () => {
    const { open: openSettings } = useSettings();

    const handleOpenReceipts = useCallback(
        () => openSettings([WorkspaceSettingsPages.DOCUMENT_INBOX]),
        [openSettings],
    );

    return (
        <CommandIsland alignEnd>
            <WithHotkey
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    preventDefault: true,
                    description: "Open Receipts",
                }}
            >
                {(hotkeyHint) => (
                    <Button
                        onClick={handleOpenReceipts}
                        variant="primary"
                        size="md"
                        rightIcon={hotkeyHint}
                    >
                        Open Receipts
                    </Button>
                )}
            </WithHotkey>
        </CommandIsland>
    );
};
